// Utility functions for cashier privacy restrictions
// Cashiers can only see today's data clearly - historical data appears blurred

/**
 * Check if a date is from today (in local timezone)
 * Day resets at 00:00 (midnight)
 */
export const isToday = (dateString) => {
  if (!dateString) return false;
  
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  // Parse the date string
  let date;
  if (dateString.endsWith('Z') || dateString.includes('+') || dateString.includes('T')) {
    date = new Date(dateString);
  } else {
    date = new Date(dateString + 'Z');
  }
  
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  
  return dateOnly.getTime() === today.getTime();
};

/**
 * Check if user is a restricted role (cashier or store_manager)
 */
export const isCashierRole = (user) => {
  return user?.role === 'cashier' || user?.role === 'store_manager';
};

/**
 * Check if data should be blurred for the current user
 */
export const shouldBlurData = (user, dateString) => {
  if (!isCashierRole(user)) return false;
  return !isToday(dateString);
};

/**
 * CSS classes for blur effect
 */
export const blurClasses = {
  text: 'blur-sm select-none',
  container: 'relative',
  overlay: 'absolute inset-0 bg-gradient-to-r from-gray-100/50 to-gray-200/50 backdrop-blur-[2px] rounded flex items-center justify-center',
};

/**
 * Get blur style for inline application
 */
export const getBlurStyle = (shouldBlur) => {
  if (!shouldBlur) return {};
  return {
    filter: 'blur(4px)',
    userSelect: 'none',
    pointerEvents: 'none',
  };
};

/**
 * Format currency with optional blur
 */
export const formatCurrencyWithPrivacy = (amount, currency = 'Q', shouldBlur = false) => {
  if (shouldBlur) {
    return `${currency}***.**`;
  }
  return `${currency}${amount.toFixed(2)}`;
};
